import React from 'react';
import { Link } from 'react-router-dom';
import RelatedPages from './RelatedPages';
import './guidePage.css';

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

type GuidePageLayoutProps = {
  children: React.ReactNode;
  currentPath: string;
};

export default function GuidePageLayout({ children, currentPath }: GuidePageLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900">
        <div className="absolute inset-0">
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,_rgb(255_255_255_/_0.15)_1px,_transparent_0)] [background-size:24px_24px]" />
        </div>
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/HRO-Logo-transparent-white-logo-white-text.png"
              alt="Horse Racing Oracle"
              className="h-12"
            />
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <a
              href={FREE_TRIAL_URL}
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl"
              rel="noopener noreferrer"
            >
              Free trial
            </a>
            <Link
              to="/login"
              className="inline-flex items-center px-4 py-2 border border-white/20 text-sm font-medium rounded-md text-white bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-white/50 transition-all duration-200"
            >
              Sign in
            </Link>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 pb-16">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 px-6 py-8 sm:px-8">
          <div className="guideShell">
            {children}
          </div>
          <RelatedPages currentPath={currentPath} />
        </div>
      </article>
    </div>
  );
}
